import { canAccess } from './canAccess';
import { NavAccess, NavItem, ResolvedNavItem } from './types';

/**
 * Filter the registry to the items the user may see (preserving order) and
 * resolve each dynamic title to its i18n key.
 */
export const resolveNavItems = (items: readonly NavItem[], access: NavAccess): ResolvedNavItem[] =>
    items
        .filter((item) => canAccess(item.access, access))
        .map(({ title, ...rest }) => ({
            ...rest,
            title: typeof title === 'function' ? title(access) : title,
        }));
